@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.rides
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint

object RateRideEndpoint: EndPoint<RateRideEndpoint.Request, RateRideEndpoint.Response>() {
    class Request(
        val rideId: KmmLong,
        val rating: Double,
        val review: String?,
    )

    class Response
}